import { Box, Button, Grid } from '@material-ui/core';
import React, { FC, useState } from 'react';
import {
  useGenerateRefereeXlsFileLazyQuery,
  useRefereesCountLazyQuery,
  useRefereesSimilarCountLazyQuery,
} from '../../api';

import ClearIcon from '@material-ui/icons/Clear';
import ContentWrapper from '../layouts/ContentWrapper/ContentWrapper';
import { Count } from '../Count';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Input } from '../Inputs';
import { RefereesFilterAdditional } from './index';
import SearchIcon from '@material-ui/icons/Search';
import TuneIcon from '@material-ui/icons/Tune';
import { makeStyles } from '@material-ui/core/styles';
import { onSetRefereeFilter } from './helpers';
import { useForm } from 'react-hook-form';
import useGenerateXlsx from '../../hooks/useGenerateXlsx';

const useStyle = makeStyles((theme) => ({
  btn: {
    marginRight: theme.spacing(2),
  },
}));

const Referees: FC<{
  onSubmit?: (T: any, E: any) => void;
  value?: any;
  defaultFilter?: any;
  first: number;
}> = ({ onSubmit = () => {}, value = {}, defaultFilter = {}, first }) => {
  const style = useStyle();
  const { handleSubmit, control, errors, reset, watch, formState, setValue, getValues } = useForm({
    defaultValues: value,
  });
  const [additional, setAdditional] = useState<boolean>(Object.keys(value)?.length > 0);
  const [filter, setFilter] = useState<any>({
    ...defaultFilter,
    archive: null,
  });

  const { onDownloadFile } = useGenerateXlsx({
    lazyQuery: useGenerateRefereeXlsFileLazyQuery,
    getValues,
    setFilter: onSetRefereeFilter,
    fileName: 'referees',
    first,
  });

  const handleSearchBox = async (value: any) => {
    const { search, ...filter } = onSetRefereeFilter(value);

    setFilter(filter);
    onSubmit(filter, getValues());
  };

  return (
    <ContentWrapper>
      <form
        onSubmit={handleSubmit(handleSearchBox)}
        onReset={(e?) => {
          setValue('registryNumber', '');
          reset();
          setFilter({
            dirPerson: {
              archive: null,
            },
          });
          onSubmit(
            {
              dirPerson: {
                archive: null,
              },
            },
            {},
          );
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={3}>
            <Input
              label="Реестровый номер"
              control={control}
              error={!!errors['registryNumber']}
              name="registryNumber"
            />
          </Grid>
          <Grid item xs={3}>
            <Input label="фамилия имя отчество" control={control} error={!!errors['name']} name="name" />
          </Grid>
          {additional && <RefereesFilterAdditional watch={watch} control={control} errors={errors} />}
          <Grid item container alignItems="center">
            <Button
              variant="outlined"
              className={style.btn}
              color="primary"
              type="reset"
              onClick={() => {
                reset({
                  registryNumber: '',
                  name: '',
                  previousLastname: '',
                  email: '',
                  guid: '',
                  displayNumber: '',
                  clsStatusPerson: '',
                  dirRegion: '',
                  dirCountry: null,
                  dirForeignCity: null,
                  dirSport: null,
                  clsRefereeCategory: null,
                  dirOrganization: null,
                  isSelfTraining: null,
                  isRussia: null,
                  isValid: null,
                  isDuplicated: null,
                  archive: { value: false, label: 'Нет' },
                  birthday_gte: null,
                  birthday_lte: null,
                });
              }}
              size="small"
              startIcon={<ClearIcon />}
            >
              Сброс
            </Button>
            <Button
              variant="outlined"
              color="primary"
              type="submit"
              size="small"
              className={style.btn}
              startIcon={<SearchIcon />}
              disabled={!formState.isDirty}
            >
              Поиск
            </Button>
            <Button
              onClick={() => setAdditional(!additional)}
              type="button"
              className={style.btn}
              variant="outlined"
              color="primary"
              size="small"
              startIcon={<TuneIcon />}
            >
              Фильтр
            </Button>
            <Box pl={4}>
              <Button
                variant="outlined"
                color="primary"
                disabled={!formState.isDirty}
                onClick={onDownloadFile}
                size={'small'}
                startIcon={<GetAppIcon />}
              >
                XLS
              </Button>
              <Count
                key={JSON.stringify(filter)}
                hasSimilarQuery
                query={filter?.name ? useRefereesSimilarCountLazyQuery : useRefereesCountLazyQuery}
                filter={filter}
              />
            </Box>
          </Grid>
        </Grid>
      </form>
    </ContentWrapper>
  );
};

export default Referees;
